export default {
  concert1: ['【中國移動香港 Privilege Club呈獻：', 'Hana 菊梓喬「只想與你在一起」演唱會】登記獲取免費$680門票2張'],
  concert2: ['日期', '時間', '地點'],
  concert3: [[' 2019年8月24及25日', '(星期六及日)'], ['晚上8時15分正開始演唱會', '(晚上6時30分開始登記入場)'], ['九龍灣展貿徑一號', '九龍灣國際展貿中心3樓', '匯星Star Hall']],
  concert4: '注意事項',
  concert5: ['登記換領『中國移動香港Privilege Club呈獻: Hana菊梓喬「只想與你在一起」演唱會』免費門票，名額有限。每位合資格Privilege Club 會員/特選客戶可帶同一名親友參加。如活動當日多於一位親友到場，該名親友將會不被安排入場。\n',
    '須填妥以下表格以作活動的登記、核對及聯絡之用。\n',
    '中國移動香港會挑選上述問題 「您最想同哪一位一同欣賞Hana菊梓橋演唱會?原因為何? 」中，有創意的客戶送出演唱會門票，每位客戶2張 (名額100個)。門票數量有限，送完即止。活動截止登記日期為2019年7月28日。',
    '成功獲邀參與之客戶將於2019年8月7日經MyLink App收到活動確認通知。如於此日期前未有收到活動確認通知，即不獲邀請參與此活動。\n',
    '成功獲邀參與之客戶請於活動當日向在場工作人員出示於MyLink App內的活動確認通知，及開啟換票証頁面，以作兌換演唱會門票及入場之用。\n',
    '座位安排以活動當日先到先得的形式分配，所兌換的門票不設座位選擇。\n',
    '成功獲邀參與之客戶須於指定時間到達指定地點參與活動，逾時不候並視為自行放棄參與是次活動之權利。\n',
    '參加者同意並授權中國移動香港、星夢娛樂集團有限公司及Event Elite Production and Promotion Limited使用其參加活動的花絮照片及影片作宣傳用途，而恕不另行通知。\n',
    '參加者同意並授權中國移動香港及Event Elite Production and Promotion Limited使用其個人資料，透過並不限於以手機短訊/智能手機訊息、電話及電郵等方式作『中國移動香港Privilege Club呈獻: Hana菊梓喬「只想與你在一起」演唱會』聯絡及入場登記用途。\n',
    '如有任何爭議，中國移動香港、星夢娛樂集團有限公司及Event Elite Production and Promotion Limited將保留最終決定權。\n',
    '如有任何查詢，請致電客戶服務熱線2945 8888。'],
  concert6: '客戶姓名',
  concert7: '中國移動香港流動電話號碼 （亦作聯絡之用）',
  concert8: '電郵地址',
  concert9: '您希望出席哪一場演唱會？',
  concert10: ['24/08/2019 (六)', '25/08/2019 (日)'],
  concert11: '條款及細則',
  concert12: ['本人同意及知悉所提供的', '條款及細則', '和', '私隱政策聲明'],
  concert14: '您已完成登記！',
  concert15: '注意：此表格只作登記用途，並不代表獲邀參與。',
  concert16: '成功登記並獲邀參與活動之客戶，將於8月7日或之前於MyLink App收到免費獲取演唱會門票活動結果。',
  concert17: '在場工作人員輸入4位數字以兌換演唱會門票\n',
  concert18: ['演唱會換票証只限所列日子當天使用，逾期無效。\n',
    '每張換票証只可使用一次並供一位客戶使用。如活動當日多於一位親友到場，該名親友將會不被安排入場。\n',
    '客戶需於活動當日向在場工作人員出示於MyLink App內的活動確認通知，及開啟換票証頁面，以作兌換演唱會門票及入場之用。不接受以MyLink App以外的形式以出示換票証。\n',
    '座位安排以先到先得的形式分配，不設選擇座位。\n',
    '獲邀之客戶須於指定時間到達指定地點參與活動，逾時不候並視為自行放棄參與是次活動之權利。\n',
    '換票証不可作轉讓、轉售或換取其他服務之用途。\n',
    '如天文台於活動開始前兩小時發出八號或以上之颱風警告信號；或黑色暴雨警告信號，活動將延期舉行。如懸掛三號風球以下或黃/紅色暴雨警告信號，活動將如期舉行。詳情請留意中國移動香港網站。\n',
    '參加者同意並授權中國移動香港、星夢娛樂集團有限公司及Event Elite Production and Promotion Limited使用其參加活動的花絮照片及影片作宣傳用途，而恕不另行通知。\n',
    '參加者同意並授權中國移動香港及Event Elite Production and Promotion Limited使用其個人資料，透過並不限於以手機短訊/智能手機訊息、電話及電郵等方式作『中國移動香港Privilege Club呈獻: Hana菊梓喬「只想與你在一起」演唱會』聯絡及入場登記用途。\n',
    '如有任何爭議，中國移動香港、星夢娛樂集團有限公司及Event Elite Production and Promotion Limited將保留最終決定權。\n',
    '如有任何查詢，請致電客戶服務熱線2945 8888。'],
  concert19: '後補名單通知',
  concert20: '獲取免費演唱會門票活動',
  concert21: '後補名單通知',
  concert22: ['感謝閣下登記!', '由於反應熱烈，是次活動名額已滿,',
    '您的登記會被列作後補名額，成功後補的客戶將於活動前1至2天收到電話通知。',
    '如有任何爭議，中國移動香港保留一切最終之決定權。',
    '如有任何查詢，請致電客戶服務熱線2945 8888。'],
  concert23: '活動確認通知',
  concert24: '成功獲取演唱會門票2張',
  concert25: '按此獲取換票証',
  concert26: '即場兌換門票',
  concert27: '換票証',
  concert28: '活動詳情',
  concert29: '抱歉 ! 您未符合參與是次活動的資格',
  concert30: '返回主頁',
  concert31: '立即報名',
  concert32: '報名表格',
  concert33: '提交',
  concert34: '完成登記',
  concert35: '提交',
  concert36: '您最想同哪一位一同欣賞Hana菊梓喬演唱會？原因為何？（有創意的客戶將有機會獲得免費演唱會2張門票，每位客戶2張，名額100個)',
  concert37: '換領碼不正確，請再輸入',
  concert38: '400字内',
  concert39: '頁面無效，請按返回。',
  concert40: ['獲取免費演唱會門票', '報名活動已完結']
}


// WEBPACK FOOTER //
// ./src/locale/concert/zh-hk.js